import { z } from 'zod';
import { UserSchema } from 'packages/lib/api/annotations-ops/contract/user-types';
import { UserQualityMetricsSchema } from 'packages/lib/api/annotations-ops/contract/quality-metrics-types';

const TeamMemberPerformanceMetricsSchema = UserQualityMetricsSchema.extend({
  overall_accuracy: z.number(),
  throughput: z.number(),
});

export const TeamMemberSchema = UserSchema.extend({
  performance: TeamMemberPerformanceMetricsSchema.optional(),
  name: z.string().optional(), // for compatibility with old team-performance
  // Add other fields that were in TeamMemberExtras if needed for gradual migration
  qualityScore: z.number().optional(),
  performanceTier: z.enum(['top', 'high', 'mid', 'low', 'default']).optional(),
});
export type TeamMember = z.infer<typeof TeamMemberSchema>;
